/**
 * Tailwind CSS breakpoint values in pixels.
 *
 * These MUST stay in sync with globals.css (@theme) and Tailwind v4 defaults.
 * Custom breakpoints (xxs, xs) are defined in globals.css.
 * Standard breakpoints (sm, md, lg, xl, 2xl) are Tailwind v4 defaults.
 */
export const BREAKPOINTS = {
  xxs: 384,
  xs: 448,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

export type BreakpointName = keyof typeof BREAKPOINTS;
